import React from 'react';

const Footer = () => {
    return (
        <div className="text-center mt-2">
            <p>Copyright &copy; {new Date().getFullYear()} || All rights reserved by Tanmoy Parvez.</p>
        </div>
    );
};

export default Footer;